export enum RolePolicyActionEnum{
    MANAGE = 'manage',
    READ = 'read',
    CREATE = 'create',
    UPDATE = 'update',
    DELETE = 'delete',
    INVITE = 'invite',
    STATUS = 'status',
    ASSIGN = 'assign',
}